module.exports = __webpack_public_path__ + "img/copytrade_sec3_1.48a324f6.png";